module.exports = __webpack_public_path__ + "img/footer_logo_kr.6a91636.svg";